import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProfileService } from 'src/app/core/services/profile.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';

@Component({
  selector: 'app-renew-content',
  templateUrl: './renew-content.component.html',
  styleUrls: ['./renew-content.component.scss']
})
export class RenewContentComponent implements OnInit {

  contentLoader = true;
  // loggedInUser;
  @Input() public currentUser;
  // @Input() currentUser: any;
  loggedInUser;
  constructor(
    private authService: AuthService,
    private activeModal: NgbActiveModal,
  ) {
    this.loggedInUser = this.authService.getCurrentUser().user;
  }

  ngOnInit() {
  }
  closeModal(type) {
    this.activeModal.close(type);
  }
  closeDialog() {
    this.activeModal.close();
  }
}
